import * as React from 'react';
import { IgcRangeSliderComponent as Component } from 'igniteui-webcomponents';
import type { IgcRangeSliderComponentEventMap } from 'igniteui-webcomponents';
import { type EventName, createComponent } from '../react-props.js';

/**
 * A range slider component used to select two numeric values within a range.
 * @fires igcInput - Emitted when a value is changed via thumb drag or keyboard interaction.
 * @fires igcChange - Emitted when a value change is committed on a thumb drag end or keyboard interaction.
 * @csspart base - The base wrapper of the slider.
 * @csspart ticks - The ticks container.
 * @csspart tick-group - The tick group container.
 * @csspart tick - The tick element.
 * @csspart tick-label - The tick label element.
 * @csspart tick-label-inner - The inner element of the tick label.
 * @csspart thumbs - The thumbs container.
 * @csspart thumb - The thumb element.
 * @csspart thumb-label - The thumb tooltip label container.
 * @csspart thumb-label-inner - The thumb tooltip label inner element.
 * @csspart track - The track container.
 * @csspart steps - The track steps element.
 * @csspart inactive - The inactive element of the track.
 * @csspart fill - The filled part of the track.
 * @class
 */
export const IgrRangeSlider = /* @__PURE__ */ createComponent({
  tagName: 'igc-range-slider',
  displayName: 'IgrRangeSlider',
  elementClass: Component,
  react: React,
  events: {
    onInput: 'igcInput' as EventName<
      IgcRangeSliderComponentEventMap['igcInput']
    >,
    onChange: 'igcChange' as EventName<
      IgcRangeSliderComponentEventMap['igcChange']
    >,
  },
});

export type IgrRangeSlider = Component;

/** @deprecated Module register is no longer needed and can be removed */
export const IgrRangeSliderModule = Component;
